import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { LeaseFlowMark } from "@/components/Logo";

export function FinalCtaSection() {
  return (
    <section className="py-20 md:py-24">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="rounded-2xl bg-navy-900 text-white p-10 md:p-16 relative overflow-hidden">
          <div
            className="absolute inset-0 opacity-30"
            style={{
              backgroundImage: "radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px)",
              backgroundSize: "22px 22px",
            }}
          />
          <div className="relative">
            <LeaseFlowMark size={44} />
            <h2 className="mt-6 h-display text-3xl md:text-5xl !text-white max-w-2xl">
              Ready to reduce client confusion?
            </h2>
            <p className="mt-5 text-navy-200 max-w-xl">
              See a 15-minute demo with your own use case. We'll walk you through how a typical lease extension looks in LeaseFlow.
            </p>
            <div className="mt-9 flex flex-wrap gap-3">
              <Link to="/demo" data-testid="final-cta-demo" className="btn-accent">
                Book Your Demo <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/pricing" data-testid="final-cta-pricing" className="inline-flex items-center gap-2 px-5 py-3 border border-white/20 hover:bg-white/5 text-white text-sm font-medium rounded-lg">
                See pricing
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
